<span *ngIf="type === 'pro'" class="pro">PRO</span>
<span *ngIf="type === 'new'" class="new">NEW</span>